import React, { useCallback, useContext } from 'react';
import { message, Modal } from 'antd';
import md5 from 'md5';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import service from '../../../service/authorization';
import LoginProvider from '../context';

const { confirm } = Modal;
const { SUCCESS, FAILED, FORCE, MODIFY } = service;

interface Service {
  login: (params?: any) => any;
  fields: any;
}

export function useLogin(service: Service) {
  // const { login } = service;
  const { setLoading, onSuccess, service: authService } = useContext(LoginProvider);
  // 登录成功后，请求基础数据
  const handleSuccess = useCallback(() => {
    // afterSuccess();
    if (onSuccess) onSuccess();
  }, [onSuccess]);
  const onFinish = useCallback(async (values: any) => {
    setLoading(true);
    const { status, message: msg, token } = await service.login({ ...values, password: md5(values.password) });

    // 处理登录成功
    if (status === SUCCESS) {
      message.success('登录成功');
      handleSuccess();
    }

    // 处理登录失败
    if (status === FAILED) {
      message.error(msg);
    }

    // 处理强制登录
    if (status === FORCE) {
      confirm({
        title: '确认继续',
        content: '当前用户已异地登录,点击"确定"将继续本机的登录, 异地登录将退出。',
        icon: <ExclamationCircleOutlined />,
        async onOk () {
          const forceStatus = await authService?.forceLogin({
            username: values.username,
            token,
          });
          if (forceStatus?.status === SUCCESS) {
            message.success('登录成功');
            await handleSuccess();
          } else {
            message.error('登录失败，请联系管理员');
          }
        },
      });
    }
    if (status === MODIFY) {
      confirm({
        title: '确认继续',
        content: '当前用户需修改密码，点击确定前往密码修改页。',
        icon: <ExclamationCircleOutlined />,
        async onOk () {
          // TODO: 改为history.push
          window.location.href = `/login/edit-password?username=${values.username}`;
        },
      });
    }
    setLoading(false);
  }, [authService, service, setLoading, handleSuccess]);
  return onFinish;
}
